import { createSlice } from "@reduxjs/toolkit";

export const profileSlice = createSlice({
  name: "profile",
  initialState: {
    profile:{}
  },
  reducers: {
    set_user: (state, action) => {
      state.profile = action.payload;
    },
  },
});

export const { set_user } = profileSlice.actions;

export default profileSlice.reducer;
